import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./shared/layout/index/layout-index'),

    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/home/home.routes'),
      },
    ],
  },
];